var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8087 17.4088C15.2945 17.177 18.0712 14.361 18.2996 10.8257C18.3444 10.1339 18.3444 9.41742 18.2996 8.72558C18.0712 5.19029 15.2945 2.37426 11.8087 2.14254C10.6194 2.06349 9.37781 2.06365 8.191 2.14254C4.70516 2.37426 1.92851 5.19029 1.70004 8.72558C1.65533 9.41742 1.65533 10.1339 1.70004 10.8257C1.78325 12.1133 2.3527 13.3055 3.02309 14.3122C3.41234 15.0169 3.15546 15.8965 2.75001 16.6648C2.45768 17.2188 2.31151 17.4958 2.42887 17.6959C2.54623 17.896 2.80839 17.9024 3.33269 17.9151C4.36956 17.9404 5.06874 17.6464 5.62374 17.2372C5.93851 17.0051 6.09589 16.889 6.20437 16.8757C6.31284 16.8623 6.52631 16.9502 6.95318 17.126C7.33684 17.2841 7.78231 17.3816 8.191 17.4088C9.37781 17.4876 10.6194 17.4878 11.8087 17.4088Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7.94868C8.75 7.24062 9.30964 6.66663 10 6.66663C10.6904 6.66663 11.25 7.24062 11.25 7.94868C11.25 8.2039 11.1773 8.44171 11.0519 8.64149C10.6784 9.23693 10 9.80472 10 10.5128V10.8333",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5H10.0075",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.3c86ec6474d89906c8a34478f3dbd41e.svg";
export { ForwardRef as ReactComponent };